import * as React from "react";
import { AuthProvider } from "@anydo/auth-react";
import { IAnydoAuth } from "@anydo/interfaces";
import { authPromise } from "@/lib/auth";

export const AppAuthProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const [auth, setAuth] = React.useState<IAnydoAuth>();

  React.useEffect(() => {
    authPromise.then(setAuth);
  }, []);

  return auth ? <AuthProvider auth={auth}>{children}</AuthProvider> : <>{children}</>;
};
